import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ULFLAG from '../../Assets/images/ukFlag.png';
import SAFLAG from '../../Assets/images/spanishFlag.png';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import { getFromStorage, saveToStorage, syncMomentLocaleFromAppLanguage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import { LanguageConstants } from '../../constants/LanguageConstants';

type LanguageDropdownProps = {
  /** Unique DOM id for Bootstrap dropdown (required if multiple instances on one page). */
  instanceId?: string;
};

/**
 * Same language switcher as header/footer, storage + optional LangUpdate API when logged in.
 */
function LanguageDropdown({ instanceId = 'langDropdown' }: LanguageDropdownProps) {
  const profiledata = useSelector((state: any) => state?.ProfileState);
  const updateLang = useMakeRequest();
  const Translate: any = getFromStorage({ key: StorageConstant?.Translate });

  const handelLanguage = (lang: string) => {
    if (profiledata?.data?.data) {
      const payload = { lang_id: lang === 'spa' ? '2' : '1' };
      updateLang.makeRequest({ payload, url: ApiConstants?.LangUpdate, toastStatus: false });
      saveToStorage({ key: 'Translate', value: lang });
      syncMomentLocaleFromAppLanguage();
    } else {
      saveToStorage({ key: 'Translate', value: lang });
      syncMomentLocaleFromAppLanguage();
      window.location.reload();
    }
  };

  useEffect(() => {
    if (updateLang?.status) {
      window.location.reload();
    }
  }, [updateLang?.status]);

  return (
    <>
      <div className="lang-dropdown">
        {getFromStorage({ key: 'Translate' }) === 'spa' ? (
          <i style={{ width: '30px', height: '30px', paddingLeft: '3px' }}>
            <img src={SAFLAG} alt="" />
          </i>
        ) : (
          <i style={{ width: '30px', height: '30px', paddingLeft: '3px' }}>
            <img src={ULFLAG} alt="" />
          </i>
        )}

        <div className="dropdown">
          <button
            className="dropdown-toggle"
            type="button"
            id={instanceId}
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {Translate === 'spa' ? 'ES' : 'EN'}
          </button>
          <ul className="dropdown-menu" aria-labelledby={instanceId}>
            <li onClick={() => handelLanguage('en')} style={{ cursor: 'pointer' }}>
              <a className="dropdown-item" href="#lang" onClick={(e) => e.preventDefault()}>
                {LanguageConstants?.ENGLISH}
              </a>
            </li>
            <li onClick={() => handelLanguage('spa')} style={{ cursor: 'pointer' }}>
              <a className="dropdown-item" href="#lang" onClick={(e) => e.preventDefault()}>
                {LanguageConstants?.SPANISH}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default LanguageDropdown;
